import React from 'react'

import ContentPage from './ContentPage.jsx'

import es from '../locales/aboutUs_es.json'
import en from '../locales/aboutUs_en.json'

function AboutUs() {
    return <ContentPage es={es} en={en} />
}

export default AboutUs
